export default {
      id: "ic-home-exemples-usage",
      viewBox: "0 0 48.2 48.2",
      url: "../dist/images/" + "sprite.svg#ic-home-exemples-usage",
      toString: function () {
        return this.url;
      }
    }